import(/* webpackMode: "eager" */ "/vercel/path0/src/app/u/[username]/error.tsx");
